import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Input,
  InputNumber,
  Radio,
  DatePicker,
  message,
  Flex,
} from "antd";
import { useForm, Controller } from "react-hook-form";
const { TextArea } = Input;

import dayjs from "dayjs";

const ModalComponent = ({
  isVisible,
  onClose,
  mode,
  initData,
  initialValues,
  handleAdd,
  handleEdit,
  handleDelete,
  column,
}) => {
  console.log(mode);
  // console.log(initData);
  // console.log(initialValues);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues,
  });

  useEffect(() => {
    if ((mode === "edit" || mode === "view" || mode === "delete") && initData) {
      console.log("kesini apa ga");

      reset(initData);
    } else {
      console.log("kesini ga");
      reset(initialValues);
    }
  }, [mode, initData, reset]);

  const onSubmit = (data) => {
    if (mode === "add") {
      handleAdd(data);
    } else if (mode === "edit") {
      handleEdit(data);
    } else if (mode === "delete") {
      handleDelete(data);
    }
    onClose();
  };

  const titles = {
    add: "Tambah Data",
    delete: "Delete Data",
    edit: "Edit Data",
    view: "Detail Data",
  };

  const btnText = {
    add: "Tambah",
    delete: "Delete",
    edit: "Update",
    view: "Oke",
  };

  return (
    <Modal
      // style={{
      //   top: 20,
      // }}
      centered
      title={titles[mode] || ""}
      open={isVisible}
      onOk={handleSubmit(onSubmit)}
      onCancel={onClose}
      width={600}
      // okText={mode != "view" ? (mode === "add" ? "Tambah" : "Update") : null}
      footer={
        <>
          <Button onClick={onClose}>Cancel</Button>

          {mode === "delete" ? (
            <Button type="primary" danger onClick={handleSubmit(onSubmit)}>
              Delete
            </Button>
          ) : (
            <Button
              type="primary"
              htmlType="submit"
              onClick={handleSubmit(onSubmit)}
              form="custom-modal-form"
            >
              {btnText[mode]}
            </Button>
          )}
        </>
      }
    >
      {mode === "delete" ? (
        <p>Are you sure you want to delete this data?</p>
      ) : (
        <form className="flex flex-col gap-2" id="custom-modal-form">
          {column.map((item, index) => (
            <div key={index}>
              {Array.isArray(item) ? (
                <div className={`grid grid-cols-${3} gap-4`}>
                  {item.map((i, index) => (
                    <Flex vertical gap={4} key={index}>
                      <label>
                        {i.title}{" "}
                        <span className="text-red-500">
                          {i.required && "*"}
                        </span>
                      </label>
                      <Controller
                        name={i.key}
                        control={control}
                        rules={i.required && { required: i.validationText }}
                        render={({ field }) => {
                          if (i.type === "text") {
                            return (
                              <Input
                                {...field}
                                placeholder={i.placeholder}
                                size="large"
                                readOnly={mode === "view"}
                              />
                            );
                          } else if (i.type === "number") {
                            return (
                              <InputNumber
                                {...field}
                                placeholder={i.placeholder}
                                size="large"
                                readOnly={mode === "view"}
                                className="w-full"
                              />
                            );
                          } else if (i.type === "dateTime") {
                            return (
                              <DatePicker
                                // {...field}
                                // format={"YYYY-MM-DD"}
                                value={field.value ? dayjs(field.value) : null}
                                onBlur={field.onBlur}
                                onChange={(date) =>
                                  field.onChange(date?.format("YYYY-MM-DD"))
                                }
                                placeholder="Tanggal"
                                size="large"
                                className="w-full"
                                disabled={mode === "view"}
                              />
                            );
                          } else if (i.type === "textarea") {
                            return (
                              <TextArea
                                {...field}
                                placeholder={i.placeholder}
                                size="large"
                                readOnly={mode === "view"}
                                rows={3}
                              />
                            );
                          } else if (i.type === "radio") {
                            return (
                              <Radio.Group
                                {...field}
                                defaultValue={i?.options[0]?.value}
                                options={i.options}
                              />
                            );
                          }

                          return null;
                        }}
                      />
                    </Flex>
                  ))}
                </div>
              ) : (
                <>
                  <Flex vertical gap={4}>
                    <label>
                      {item.title}{" "}
                      <span className="text-red-500">
                        {item.required && "*"}
                      </span>
                    </label>
                    <Controller
                      name={item.key}
                      control={control}
                      rules={item.required && { required: item.validationText }}
                      render={({ field }) => {
                        if (item.type === "text") {
                          return (
                            <Input
                              {...field}
                              placeholder={item.placeholder}
                              size="large"
                              readOnly={mode === "view"}
                            />
                          );
                        } else if (item.type === "number") {
                          return (
                            <InputNumber
                              {...field}
                              placeholder={item.placeholder}
                              size="large"
                              readOnly={mode === "view"}
                              className="w-full"
                            />
                          );
                        } else if (item.type === "dateTime") {
                          return (
                            <DatePicker
                              // {...field}
                              // format={"YYYY-MM-DD"}
                              value={field.value ? dayjs(field.value) : null}
                              onBlur={field.onBlur}
                              onChange={(date) =>
                                field.onChange(date?.format("YYYY-MM-DD"))
                              }
                              placeholder="Tanggal"
                              size="large"
                              className="w-full"
                              disabled={mode === "view"}
                            />
                          );
                        } else if (item.type === "textarea") {
                          return (
                            <TextArea
                              {...field}
                              placeholder={item.placeholder}
                              size="large"
                              readOnly={mode === "view"}
                              rows={3}
                            />
                          );
                        } else if (item.type === "radio") {
                          return (
                            <>
                              <Radio.Group
                                {...field}
                                defaultValue={item?.options[0]?.value}
                                options={item.options}
                              />
                            </>
                          );
                        }

                        return null;
                      }}
                    />
                  </Flex>
                </>
              )}

              {/* {item.type === "text" && (
                    <Controller
                      name={item.key}
                      control={control}
                      rules={item.required && { required: item.validationText }}
                      render={({ field }) => (
                        <Input
                          {...field}
                          placeholder={item.placeholder}
                          size="large"
                          readOnly={mode === "view"}
                        />
                      )}
                    />
                  )}

                  {item.type === "number" && (
                    <Controller
                      name={item.key}
                      control={control}
                      rules={item.required && { required: item.validationText }}
                      render={({ field }) => (
                        <InputNumber
                          {...field}
                          placeholder={item.placeholder}
                          size="large"
                          readOnly={mode === "view"}
                          className="w-full"
                        />
                      )}
                    />
                  )}

                  {item.type === "textarea" && (
                    <Controller
                      name={item.key}
                      control={control}
                      rules={item.required && { required: item.validationText }}
                      render={({ field }) => (
                        <TextArea
                          {...field}
                          placeholder={item.placeholder}
                          size="large"
                          readOnly={mode === "view"}
                          rows={3}
                        />
                      )}
                    />
                  )}

                  {item.type === "radio" && (
                    <Controller
                      name={item.key}
                      control={control}
                      rules={item.required && { required: item.validationText }}
                      render={({ field }) => (
                        <Radio.Group
                          {...field}
                          defaultValue={item?.options[0]?.value}
                          options={item.options}
                        />
                      )}
                    />
                  )}

                  {item.type === "dateTime" && (
                    <Controller
                      name={item.key}
                      control={control}
                      rules={item.required && { required: item.validationText }}
                      render={({ field }) => (
                        <>
                          <br />
                          <DatePicker
                            // {...field}
                            // format={"YYYY-MM-DD"}
                            value={field.value ? dayjs(field.value) : null}
                            onBlur={field.onBlur}
                            onChange={(date) =>
                              field.onChange(date?.format("YYYY-MM-DD"))
                            }
                            placeholder="Tanggal"
                            size="large"
                            className="mt-1"
                            disabled={mode === "view"}
                          />
                        </>
                      )}
                    />
                  )} */}

              {/* message error */}
              {errors[item.key] && (
                <span className="text-red-500">{errors[item.key].message}</span>
              )}
            </div>
          ))}
        </form>
      )}
    </Modal>
  );
};

export default ModalComponent;
